import './App.scss';

import FloatIcons from './components/FloatIcons/FloatIcons';
import Footer from './components/Footer/Footer';
import NavBar from './components/NavBar/NavBar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageHome from './pages/PageHome';
import PagePortfolio from './pages/PagePortfolio';
import PageContact from './pages/PageContact';
import ThemeProvider from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <NavBar/>
          <Routes>
            <Route path='/' element={<PageHome/>}/>
            <Route path='/portafolio' element={<PagePortfolio/>}/>
            <Route path='/contacto' element={<PageContact/>}/>
            <Route path='*' element={<h1>ERROR 404 - página no encontrada</h1>}/>
          </Routes>
          <Footer/>
          <FloatIcons/>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
